/**
 * SISTEMA DE TIPOGRAFÍA OPTIMIZADO PARA RESPONSIVE
 * 
 * Tamaños adaptados para móviles, tabletas y desktop
 * Escalado progresivo para mejor legibilidad en todos los dispositivos
 */
export const typography = {
  overlineSmall: "text-xs sm:text-sm font-light tracking-[0.2em] uppercase",
  h1: "text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight",
  h2Large: "text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-light leading-tight",
  h2Medium: "text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-light leading-tight",
  h3: "text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-light leading-tight",
  overline: "text-base sm:text-lg md:text-xl lg:text-2xl font-light",
  featuredText: "text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light leading-relaxed",
  secondaryText: "text-lg sm:text-xl md:text-2xl lg:text-3xl font-light leading-relaxed",
  paragraphLarge: "text-lg sm:text-xl md:text-2xl lg:text-3xl font-light leading-relaxed",
  paragraphNormal: "text-base sm:text-lg md:text-xl lg:text-2xl font-light leading-relaxed",
  paragraphBase: "text-sm sm:text-base md:text-lg font-light leading-relaxed",
  ctaButton: "text-base sm:text-lg md:text-xl font-medium",
  ctaLink: "text-base sm:text-lg md:text-xl lg:text-2xl font-light",
} as const;
